module.exports = __webpack_public_path__ + "img/Female_Posterior_Buttocks.244f0019.png";